export default __webpack_public_path__ + "static/ponkes-2-ceced87f65266a051f49373803075a55.jpg";